import getters from './getters';
import actions from './actions';
function initState() {
    return {
        result: null,
        waiting: false,
        pageIndex: 0,
        // logs: []
    };
}

export default {
    state: initState,
    getters,
    actions
};
